import React, { useEffect, useState } from 'react'
import { bookingPageTab, bookingPageTabIds, deliveryPageTab, deliveryPageTabIds, deliveryPageTabs } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useSearchParams } from 'react-router-dom'
// import PickupAndDropoffCharge from './PickupAndDropoffCharge'
import DemurrageCharges from './demurrageCharges'
import DeliveryCharges from './deliveryCharges'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import { useTranslation } from '../../../../i18n/I18nProvider'

const GSDeliveryPage = () => {
  // const [selectedTab, setSelectedTab] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || '')
  const [allTabs, setAllTabs] = useState([])
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);
    if (selectedTab === '') {
      const newData=deliveryPageTabs.filter((item)=>findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1? item:null)
      goToTabs(newData?.[0]?.JobID)
    }
    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    }else{
      setAllTabs([])
    }
  }, [searchParams,selectedTab])

  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }

  const getDeliveryPageContent = (typeId, label) => {
    switch (typeId) {
      case 318:
        return <DemurrageCharges />
      case 340:
        return <DeliveryCharges />
      default:
        return label
    }
  }
  return (
    <>
      <Box className="bookingPageTabContainer">
        <Item>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => goToTabs(newValue)}
              variant="scrollable"
              aria-label="delivery page tabs"
            >
              {/* {deliveryPageTab.map((reqType, index) => (
                <Tab key={`sender_${index}`} label={reqType} {...deliveryPageTabIds(index)} />
              ))} */}
              {deliveryPageTabs.map((reqType, index) => (
                <Tab key={`sender_${index}`} value={reqType.JobID} label={gs?.[reqType.translationKey] || reqType.name} {...deliveryPageTabIds(reqType.JobID)}
                sx={{
                  display:
                    findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                      ? 'block'
                      : 'none',
                }}
                />
              ))}
            </Tabs>
          </Box>
          {deliveryPageTabs.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
              style={{
                display:
                  findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                    ? 'block'
                    : 'none',
              }}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getDeliveryPageContent(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default GSDeliveryPage
